import React from 'react';

import { EntityLayout } from '@backstage/plugin-catalog';

import { OverviewContent } from '../Content';

export const JiraTeamPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      {OverviewContent}
    </EntityLayout.Route>
  </EntityLayout>
);
